import { EnumType, Enum } from 'ts-jenum';

@Enum<ChangesToHeadsetState>('value')
export class ChangesToHeadsetState extends EnumType<ChangesToHeadsetState>() {
   static readonly MuteHeadset = new ChangesToHeadsetState(0);
   static readonly UnmuteHeadset = new ChangesToHeadsetState(-1);
   static readonly Hold = new ChangesToHeadsetState(-2);
   static readonly Resume = new ChangesToHeadsetState(-3);
   static readonly OnHook = new ChangesToHeadsetState(-4);
   static readonly OffHook = new ChangesToHeadsetState(-5);
   static readonly IncomingCall = new ChangesToHeadsetState(-6);
   static readonly OutgoingCall = new ChangesToHeadsetState(-7);
   private constructor(public readonly value: number) {
      super();
   }
}
